export default __webpack_public_path__ + "static/media/fuel.3d73be08.svg";